<template>
    <div v-show="total != 0" :class="[pageClass]">
        <span class="hz-pagination-total">共{{total}}条</span>
        <hz-select style="width: auto;" :iptStyle="iptStyle" v-if="layout.indexOf('sizes') > -1" v-model="pageSizeVal" :items="pageSizeMenu" @change="switchLength"></hz-select>
        <ul>
            <li :class="{disabled:currentPage == 1}" @click="switchPage('first', $event)">首页</li>
            <li :class="{disabled:currentPage == 1}" @click="switchPage('previous', $event)">«</li>
            <li :class="{active:(num == currentPage)}" v-for="(num,index) in pageNumbers" :key="index" @click="switchPage(num, $event)">{{num}}</li>
            <li :class="{disabled:currentPage == totalPage}" @click="switchPage('next', $event)">»</li>
            <li :class="{disabled:currentPage == totalPage}" @click="switchPage('last', $event)">尾页</li>
        </ul>
        <span v-if="layout.indexOf('jumper') > -1" class="hz-pagination-jump">前往<input v-model="jumpPage" @keyup.enter="handleJumpPage"/>页</span>
    </div>
</template>

<script>
    import HzSelect from './select';
    export default {
        components: { HzSelect },
        name: "hz-page",
        props: {
            currentPage: { type: [String, Number], default: 1},
            pageSizes: { type: Array, default: function(){return [10, 20, 50, 100]}},
            pageSize: { type: [String, Number], default: 10},
            layout: { type: String, default: 'sizes, jumper'},
            total: { type: [String, Number], default: 0},
            align: { type: String, default: 'right'}
        },
        data(){
            return {
                pageSizeVal: this.pageSize,
                jumpPage: this.currentPage,
                pageNumberSize: 5,
                pageClass : {
                    "hz-pagination": true,
                    "hz-pagination-right": false,
                    "hz-pagination-center": false
                },
                iptStyle: {
                    width: "78px",
                    "margin-right": "10px",
                    "height": "28px",
                    "line-height": "28px",
                    "padding": "0 4px"
                }
            };
        },
        computed:{
            pageSizeMenu: function(){
                if(this.pageSizes.indexOf(parseInt(this.pageSizeVal)) == -1){
                    this.pageSizes.push(parseInt(this.pageSizeVal))
                    
                }
                this.pageSizes.sort((a, b) => a - b);
                const rsObj = {};
                this.pageSizes.map(item => {
                    rsObj[`${item}条/页`] = item;
                })
                return rsObj
            },
            totalPage: function(){
                return Math.ceil(this.total / this.pageSizeVal);
            },
            pageNumbers: function(){
                let start, end, nums = [], pNum = this.currentPage, half = Math.floor(this.pageNumberSize / 2);
                if(this.totalPage < this.pageNumberSize) {
                    start = 1;
                    end = this.totalPage;
                } else if ( pNum <= half ) {
                    start = 1;
                    end = this.pageNumberSize;
                } else if ( pNum >= (this.totalPage - half) ) {
                    start = this.totalPage - this.pageNumberSize + 1;
                    end = this.totalPage;
                } else {
                    start = pNum - half;
                    end = start + this.pageNumberSize - 1;
                }
                for(let i = start;i <= end; i++){
                    nums.push(i);
                }
                return nums;
            }
        },
        methods:{
            handleJumpPage(){
                if(!this.jumpPage) return ;
                const reg = /^[1-9]*[1-9][0-9]*$/;
                
                if(!this.jumpPage.toString().match(reg)){
                    this.jumpPage = '';
                    return ;
                }
                if(this.jumpPage > this.totalPage){
                    this.jumpPage = this.totalPage;
                }
                this.goPage(this.jumpPage);
            },
            goPage(pNum){
                this.jumpPage = pNum;
                this.$emit('update:currentPage', pNum)
                this.$emit('current-change',pNum);
            },
            switchPage(pNum, event){
                const $obj = $(event.target).closest("li");
                if($obj.hasClass("disabled") || $obj.hasClass("active")){
                    return ;
                }
                let num;
                if(isNaN(pNum)){
                    switch (pNum){
                        case 'first':
                            if(this.currentPage != 1) num = 1;
                            break;
                        case 'previous':
                            if(this.currentPage != 1) num = this.currentPage - 1;
                            break;
                        case 'next':
                            if(this.currentPage != this.totalPage) num = this.currentPage + 1;
                            break;
                        case 'last':
                            if(this.currentPage != this.totalPage) num = this.totalPage;
                            break;
                    }
                }else{
                    num = pNum;
                }

                this.goPage(num);
            },
            switchLength(){
                if(this.currentPage > this.totalPage){
                    this.jumpPage = this.totalPage;
                    this.$emit('update:currentPage', this.totalPage)
                }
                this.$emit("size-change", this.pageSizeVal);
            }
        },
        mounted(){
            if(this.align == 'center')
                this.pageClass["hz-pagination-center"] = true;
            else if(this.align == 'right')
                this.pageClass["hz-pagination-right"] = true;
        }
    }
</script>


// WEBPACK FOOTER //
// src/pagination.vue